var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHomeBasket = function SvgHomeBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#15264C",
    cx: 75,
    cy: 75,
    r: 75
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.404 43.463-25.946 26.79a1.642 1.642 0 0 0 0 2.274c.611.63 1.59.63 2.202 0l24.839-25.648 24.838 25.648c.611.63 1.591.63 2.202 0 .3-.31.461-.726.461-1.13 0-.405-.15-.822-.461-1.131L76.594 43.475a1.513 1.513 0 0 0-2.19-.012zm20.443 40.145c.431.007.84.188 1.126.474.286.286.475.687.473 1.126l-.402 18.29c.008.322-.082.62-.244.869a1.642 1.642 0 0 1-1.366 1.08l-.148.01-18.536-.2-18.536.2a1.64 1.64 0 0 1-1.515-1.092 1.505 1.505 0 0 1-.24-.708l-.405-18.45a1.59 1.59 0 0 1 .473-1.125 1.646 1.646 0 0 1 1.126-.474 1.516 1.516 0 0 1 1.552 1.413l.432 16.844 17.113.204 17.113-.204.428-16.7a1.518 1.518 0 0 1 1.556-1.557z",
    stroke: "#FFF",
    strokeWidth: 4,
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgHomeBasket;